import styled from 'styled-components';

import { sizeUp } from '~/theme';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  paddingInline: sizeUp('10rem', ['md', '20rem']),
  paddingBlockStart: '30rem',

  fontFamily: theme.typography.family.arial,
}));

export const SubTitleContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',

  paddingBlockStart: '20rem',
});

export const Title = styled.span(({ theme }) => ({
  fontSize: theme.typography.size20,
  color: theme.palette.erieBlack,
  textTransform: 'uppercase',
}));

export const SubTitle = styled.p(({ theme }) => ({
  fontSize: theme.typography.size16,
  color: theme.palette.darkLiver,

  margin: 0,
}));
